<template>    
  <div class="right">
    <div class="right__fixed">
      <div class="right__header">
        <div class="right__header__title">科普文章投稿须知</div>
        <div class="right__header__btnWarp">
          <div class="right__header__btn" @click="onAsk">投稿要求</div>
          <div class="right__header__btn" style="width: 116.5rem;" @click="onNotice">通知与文件</div>
          <div class="right__header__btn" @click="onConsult">投稿咨询</div>
          <div class="right__header__btn" style="width: 116.5rem;" @click="onCertificate">发表证书</div>
        </div>
      </div>
      <div class="right__content">
        <div class="right__content__title">杂志介绍</div>
        <div class="right__content__text">{{`主管单位 :   国家卫生健康委员会
          主办单位 :   人民卫生出版社有限公司
          国际刊号 :   2095-7793
          国际内号 :   11-9350/R`}}
        </div>
        <div class="right__content__text">{{`足踝外科电子杂志创刊于2014年6月，是由国家卫生健康委员会主管、人民卫生出版社有限公司主办的足踝专业学术电子期刊。`}}</div>
        <div class="right__content__text">{{`主要刊登足踝外科医疗理念进展、临床诊疗技术，以及与临床联系紧密的基础研究、实验研究成果，是目前该领域内容最为丰富的杂志。`}}</div>
        <div class="right__content__text" style="margin-bottom: 0; padding-bottom: 5rem;">{{`本刊坚持刊文真实、严谨和科学的原则。充分体现电子杂志的特点，将经典手术、争鸣交流呈现在读者的眼前;以满足广大足踝外科医生对专业水平提高的迫切要求，促进我国足踝外科的进一步发展。`}}</div>
      </div>
      <div class="right__copyright">
        <div class="right__copyright__text right__copyright__hover" @click="onBeian">网站备案/许可证号：京ICP备2021017194号</div>
        <div class="right__copyright__text">版权所有 © 足踝外科电子杂志</div>
      </div>
    </div>
  </div>
</template>

<script>
// import { get } from '../../utils/request'

export default {
  name: "PageRight",
  props: [
    
  ],    
  data() {
    return {
      
    }
  },
  mounted() {    
    const that = this
     
  },
  methods: {
    onNotice() {
      let routeData = this.$router.resolve({ path: '/detail/3' });
      window.open(routeData.href, '_blank');
    },
    onAsk() {
      let routeData = this.$router.resolve({ path: '/ask' });
      window.open(routeData.href, '_blank');
    },
    onConsult() {
      let routeData = this.$router.resolve({ path: '/consult' });
      window.open(routeData.href, '_blank');
    },
    onCertificate() {
      let routeData = this.$router.resolve({ path: '/certificate' });
      window.open(routeData.href, '_blank');
    },
    onBeian() {
      window.open('https://beian.miit.gov.cn', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
  .right {
    min-width: 262rem;
    max-width: 262rem;
    display: flex;
    flex-direction: column;

    &__fixed {
      min-width: 262rem;
      max-width: 262rem;
      // position: fixed;
      // top: calc(53rem + 19.5rem);
      // right: 79rem;
    }
    
    &__header {
      max-width: 100%;
      padding: 9.5rem 14.5rem 6rem;
      margin-bottom: 19rem;
      background-color: #fff;
      border-radius: 5rem;

      &__title {
        font-size: 14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 22rem;
        display: flex;
        margin-bottom: 8rem;
      }

      &__btnWarp {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      &__btn {
        box-sizing: border-box;
        width: 108.5rem;
        height: 34rem;
        background: #F5F8F9;
        border-radius: 5rem;
        margin-bottom: 7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 22rem;
      }

      &__btn:hover {
        cursor: pointer;
      }
    }

    &__content {
      padding: 7.5rem 14.5rem 8rem;
      margin-bottom: 17rem;
      background: #FFFFFF;
      border-radius: 5rem;

      &__title {
        font-size: 14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 22rem;
        display: flex;
        margin-bottom: 5rem;
      }

      &__text {
        font-size: 10rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #242424;
        line-height: 21.5rem;
        white-space: pre-line;
        display: flex;
        margin-bottom: 11.5rem;
      }
    }

    &__copyright {
      display: flex;
      width: 100%;
      align-items: center;
      flex-direction: column;

      &__text {
        display: flex;
        font-size: 9rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #888888;
        line-height: 22rem;
      }

      &__hover:hover {
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PageRight/index.vue